import React, { memo } from "react";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../../../redux/store";
import { trackViewFullScreenVisualizer, trackViewInterior, trackVisualizerShowCar } from "../../../../utils/tracking";
import { hideModal, showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_FULLSCREEN_CAR_SPIN } from "../../../../utils/modalConstants";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./SpinNavigation.module.scss";
import { setActiveSpin, SpinnerType } from "../../../../redux/slices/CarConfigSpinNavigationSlice";
import a11y from "../../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import { UPHOLSTERY_SPIN_ID } from "./Upholstery";
import { EXTERIOR_SPIN_ID } from "./exterior-360/Exterior360Wrapper";
import { CarConfigLabel, useCarConfigLabel } from "../../../../utils/labelUtils";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

export const SPIN_CONTAINER_ID = "spin-container-wrapper";

type SpinNavigationProps = {
    inModal?: boolean;
    showFullscreen?: boolean;
};

const SpinNavigation: React.FC<SpinNavigationProps> = (props) => {
    const { inModal, showFullscreen } = props;
    const activeSpin = useCarConfigSelector((state) => state.carConfigSpinNavigation.activeSpin);
    const activeSection = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

    const carConfig360SpinCar = useCarConfigLabel("carConfig360SpinCar");
    const carConfigInterior = useCarConfigLabel("carConfigInterior");

    const dispatch = useDispatch<CarConfigDispatchType>();

    const navigationLabel = useCarConfigLabel("carConfigA11yNavSpin");

    return (
        <nav className={styles["spin-navigation"]} aria-label={navigationLabel}>
            <ul className={styles["spin-navigation-list"]}>
                <li>
                    <Button
                        variant="btn-icon-text"
                        className={styles["spin-toggle"]}
                        aria-controls={EXTERIOR_SPIN_ID}
                        aria-expanded={activeSpin === SpinnerType.Car}
                        onClick={() => {
                            trackVisualizerShowCar(activeSection);
                            dispatch(setActiveSpin(SpinnerType.Car));
                        }}
                    >
                        <Icon variant="car" sizing="sm" aria-hidden="true" />
                        <span className={styles["spin-toggle-text"]}>{carConfig360SpinCar}</span>
                    </Button>
                </li>
                <li>
                    <Button
                        variant="btn-icon-text"
                        className={styles["spin-toggle"]}
                        aria-controls={UPHOLSTERY_SPIN_ID}
                        aria-expanded={activeSpin === SpinnerType.Upholstery}
                        onClick={() => {
                            trackViewInterior(activeSection);
                            dispatch(setActiveSpin(SpinnerType.Upholstery));
                        }}
                    >
                        <Icon variant="interior-car" sizing="sm" aria-hidden="true" />
                        <span className={styles["spin-toggle-text"]}>{carConfigInterior}</span>
                    </Button>
                </li>
                {showFullscreen && (
                    <li>
                        <Button
                            variant="btn-icon-dark"
                            circle
                            onClick={() => {
                                if (!inModal) trackViewFullScreenVisualizer(activeSection);
                                dispatch(
                                    inModal
                                        ? hideModal(MODAL_FULLSCREEN_CAR_SPIN)
                                        : showModal({ type: MODAL_FULLSCREEN_CAR_SPIN }),
                                );
                            }}
                            className={styles["full-screen"]}
                            aria-controls={SPIN_CONTAINER_ID}
                            aria-expanded={inModal}
                        >
                            <Icon
                                variant={inModal ? "exit-full-screen" : "full-screen"}
                                sizing="sm"
                                aria-hidden="true"
                            />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigA11yButtonToggleFullScreen" />
                            </span>
                        </Button>
                    </li>
                )}
            </ul>
        </nav>
    );
};

export default memo(SpinNavigation);
